export class Moment {
  constructor(time) {
    if (time) {
      const timeString =
        typeof time === 'string'
          ? time.replace(new RegExp('-', 'g'), '/')
          : time; // for firefox.
      this.Date = new Date(timeString);
    } else {
      this.Date = new Date();
    }
  }

  getFullYear = () => this.Date.getFullYear();
  getTime = () => this.Date.getTime();
  static diff = (a, b) => new Moment(a).getTime() - new Moment(b).getTime();
  getDateDetails = () => {
    const d = this.Date;
    const year = d.getFullYear();
    const month = d.getMonth() + 1; // 0:Jan, 1:Fab ...
    const date = d.getDate();
    const hour = d.getHours();
    const minute = d
      .getMinutes()
      .toString()
      .padStart(2, 0);
    const second = d
      .getSeconds()
      .toString()
      .padStart(2, 0);

    return {
      year,
      month,
      date,
      hour,
      minute,
      second,
    };
  };
}



// WEBPACK FOOTER //
// ./app/utils/moment.js